import { Logo } from '@/components/Logo';
import type { Me } from '@/types/me';
import { NavGroups } from './NavGroups';
import type { NavItem } from './nav-items';
import { SidebarFooter } from './SidebarFooter';
import { TimerIndicatorSlot } from './TimerIndicatorSlot';

interface SidebarProps {
  items: NavItem[];
  me: Me | undefined;
}

/** Desktop (>= lg) sidebar, 224px: Logo, running-timer indicator, grouped nav, footer (owner decision 4). */
export function Sidebar({ items, me }: SidebarProps): JSX.Element {
  return (
    <aside className="hidden w-56 shrink-0 flex-col border-r border-border bg-card lg:fixed lg:inset-y-0 lg:left-0 lg:z-30 lg:flex">
      <div className="px-5 py-5">
        <Logo />
      </div>
      <TimerIndicatorSlot variant="sidebar" />
      <div className="flex-1 overflow-y-auto px-2 py-2">
        <NavGroups items={items} />
      </div>
      {me && <SidebarFooter me={me} />}
    </aside>
  );
}
